<!-- DESC：出版编辑页面 -->
<template>
    <div class="proceedingsadd-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Add New Proceedings Volume</div>
                    <br />
                    <div class="info">
                        Using the conference proceedings environment is not included in your license. Click here to upgrade
                        your license.
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 录用 -->
        <el-row>
            <el-col :span="15">
                <div class="click-tips">
                    <span class="text-line">Would you like to publish your conference proceedings in one of our open access
                        collections?</span>
                </div>
                <div class="img-box">
                    <img src="../../../public/img/computing.png">
                    <img src="../../../public/img/language.png">
                    <img src="../../../public/img/engineering.png">
                    <img src="../../../public/img/education.png">
                    <img src="../../../public/img/health.png">
                    <img src="../../../public/img/join_us.png">
                </div>
                <el-button type="danger" style="margin-top: 35px;" plain size="small"
                    @click="centerDialogVisible = true">Submit a Proposal</el-button>
            </el-col>
        </el-row>
        <!-- 隐藏层 -->
        <el-dialog v-model="centerDialogVisible" title="Confirmation Information" width="30%" align-center>
            <span>Are you sure about Submit a Proposal</span>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="centerDialogVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="okSubmit">
                        Confirm
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 隐藏层 -->
        <el-dialog v-model="dialogVisiblePublish" width="60%" align-center style="padding-bottom: 30px;">
            <div style="margin-bottom: 10px;font-weight: 700;">
                Submit a Proposal to Publish an ConfChair Volume
            </div>
            <el-text class="mx-1" type="info" size="small">We are currently only accepting proposals for publishing from
                conferences hosted by ConfChair and held in 2022 or later.
            </el-text>
            <br>
            <el-text class="mx-1" type="info" size="small">The list of such conferences where you have been a chair or a
                proceedings manager are shown below. <span style="color: #ff2222b0;">Click on the conference</span>
            </el-text>
            <br>
            <el-text class="mx-1" type="info" size="small">acronym to apply for publishing this conference proceedings as an
                EPiC volume.You will be asked to fi out a form.
            </el-text>
            <el-divider border-style="dashed" />
            <el-table :data="confinfo" style="width: 100%" border>
                <el-table-column label="Acronym" width="180" align="center">
                    <template #default="scope">
                        <el-tag type="danger" class="title-text" size="small" style="cursor: pointer;" @click="pulish">{{ scope.row.acronym }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="Name" align="center">
                    <template #default="scope">
                        <el-text type="primary" class="title-text" size="small">{{ scope.row.title }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="Year"  width="180" align="center">
                    <template #default="scope">
                        <el-text type="primary" class="title-text" size="small">{{ scope.row.year }}</el-text>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script setup>
import { ArrowLeftBold } from '@element-plus/icons-vue'
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from "vue-router";
import request from "../../network/request"

const route = useRoute()
const router = useRouter()
const centerDialogVisible = ref(false)
const dialogVisiblePublish = ref(false)
const confinfo = ref([])


// 确认提交
const okSubmit = () => {
    centerDialogVisible.value = false
    dialogVisiblePublish.value = true
}

// 出版论文
const pulish = () =>{
    router.push(`/common/paperpublish?cid=${route.query.cid}&acronym=${route.query.acronym}`)
}


// 获取会议详细信息
onMounted(()=>{
    request.post(`/conference/detail`, { cid: route.query.cid },{ headers: { 'content-type': 'multipart/form-data' }}).then((res) => {
        res.data.year = res.data.createtime.split(" ")[0].split("-")[0]
        confinfo.value = [res.data]
    })
})

</script>

<style lang="scss">
.proceedingsadd-box {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .click-tips {
        font-size: 13px;

        .text-line {
            border-bottom: 1px solid #88b5cb61;
            display: inline-block;
            margin-bottom: 20px;
            padding-bottom: 5px;
        }

        div {
            margin-bottom: 10px;
        }
    }

    .img-box {
        display: flex;

        img {
            width: 12%;
            margin-right: 20px;
            cursor: pointer;
        }
    }
}
</style>